import {
  AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, TransferState, makeStateKey,
  effect, inject, Injector, HostListener, viewChild
} from '@angular/core';
import { TDSService, TdsOutputService } from '@citi-gcg-173875/cbol-marketing-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { MktContentService, MktContentStorageService, MktDynamicOfferService, MktModalService, MktSEOService } from 'src/app/core/services';
import { Subject, Subscription, combineLatest, debounceTime, fromEvent, timer } from 'rxjs';
import { PdpRedesignService } from './pdp-redesign.service';
import { OfferUtilService, PqpsUtilService } from 'src/app/common/services';
import { FootnoteService } from 'src/app/common/services/footnote.service';
import { CommonModule, DOCUMENT, NgComponentOutlet, Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { PdpTaggingService } from './pdp-tagging.service';
import { QPStoreService } from 'src/app/common/services/qp-store.service';
import { WINDOW, WindowRef } from '@citi-gcg-173875/citi-utils';
import { AdaFriendlyNamePipe } from 'src/app/common/pipes/ada-friendly-name.pipe';
import { ScrollFocusService } from 'src/app/common/services/scroll-focus.service';


const IS_BUNDLE_LOADED_KEY = makeStateKey<boolean>('isBundleLoaded');
const PAGE_DATA_OBJ_KEY = makeStateKey<any>('pageDataObj');
const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');
const ADDITIONAL_INFO_PAGES = 'Additional_Info_Pages';
const ADDITIONAL_INFO_URL = 'additional-information';
@Component({
  selector: 'pdp-redesign',
  standalone: true,
  imports: [
    CommonModule
  ],
  providers: [TDSService],
  templateUrl: './pdp-redesign.component.html',
  styleUrl: './pdp-redesign.component.scss',
})
export default class PdpRedesignComponent implements OnInit, AfterViewInit, OnDestroy {
  public pageDataObj: any;
  public compDataExceptSticky: any;
  public pageNotFound: boolean = false;
  public pageName: string;
  public tagging_content: any;
  public isBundleLoaded: boolean;
  private sub: Subscription = new Subscription();
  private _afcCode: string;
  private intcCode: string;
  private flowId: string;
  private screenId: string;
  private prospectID: string;
  private familyProducts: string[];
  private soc: string;
  private acquisitionType: string;
  private oc: string;
  private rafid: string;
  private pid: string;
  private hashCode: string;
  private category: string;
  private aaPages = ['inflight-info', 'concierge', 'airport-live-update'];
  private aaPagesDefaultPO = {'inflight-info': 'AAInflight', 'concierge': 'AAgent', 'airport-live-update': 'AAirport'};
  private isAACategory: boolean = false;
  private isFamilyPage: boolean = false;
  mbolFlagPreLogin: string;
  mbolFlagPostLogin: string;
  private pageId: any;
  private isModalOpen: any;
  public showStickyHeader: boolean = false;
  public showStickyFooter: boolean = false;
  public stickyType: string;
  public stickyCompData: any;
  public stickyHeight: any;
  swipeCoord: [number, number];
  swipeTime: number;
  isBrowser: boolean = false;
  applyNowUrl: string;
  displayTermsUrl: string;
  aemParam: 'aem' | 'static' = 'aem';
  isInternal: boolean;
  outlet = viewChild.required(NgComponentOutlet);
  public PO: string;
  public cmp: string;
  private flagPQPS: boolean = false;
  private scrollSubject = new Subject<void>(); // Subject to handle scroll events
  private familyPriceDetails: any = {};
  constructor(
    private state: TransferState,
    private _offerUtilService: OfferUtilService,
    private route: ActivatedRoute,
    private _pdpRedesignService: PdpRedesignService,
    private mktSEOService: MktSEOService,
    private titleService: Title,
    private _mktContentService: MktContentService,
    private footnoteService: FootnoteService,
    private router: Router,
    private modalService: MktModalService,
    private renderer2: Renderer2,
    private elementRef: ElementRef,
    private _pdpTaggingService: PdpTaggingService,
    private _mktDynamicOfferService: MktDynamicOfferService,
    private _contentStorageService: MktContentStorageService,
    private tdsOutputService: TdsOutputService,
    private qpStoreService: QPStoreService,
    private adaFriendlyNamePipe: AdaFriendlyNamePipe,
    private _ada: AdaFriendlyNamePipe,
    private location: Location,
    private pqpsUtilService: PqpsUtilService,
    @Inject(DOCUMENT) private _document: Document,
    @Inject(WINDOW) private _window: WindowRef,
    private readonly scrollFocusService: ScrollFocusService
  ) {
    this.isBundleLoaded = this.state.get(IS_BUNDLE_LOADED_KEY, false);
    this.pageDataObj = this.state.get(PAGE_DATA_OBJ_KEY, null);
    this.isBrowser = this._pdpRedesignService.isBrowser;
    this._offerUtilService.isAEMPDPPage = true;
    effect(
      () => {
        this.getOutputEmitterData();
      },
      { injector: inject(Injector) }
    );
  }

  ngOnInit() {
    this._document?.documentElement?.style?.setProperty("scroll-padding-bottom", "6rem");
    this.sub.add(this.scrollSubject
      .pipe(debounceTime(500)) // Debounce scroll events by 500ms
      .subscribe(() => {
        this.handlePriceDependentEvent();
      }));
    this.sub.add(combineLatest([
      this.route.queryParams,
      this.route.params
    ]).subscribe({
      next: (params) => {
        this.pageName = params[1]['cardName'] || "";
        this.flowId = params[0]['flowId'] || "";
        this.afcCode = params[0]['afc'] || params[0]['AFC'] || "";
        this.soc = params[0]['soc'] || "";
        this.rafid = params[0]['rafid'] || "";
        this.intcCode = params[0]['intc'] || "";
        this.hashCode = params[0]['HKOP'] || "";
        this.category = params[0]['category'] || "view-all-credit-cards";
        this.aemParam = params[0]['aem'] || 'aem';
        this.PO = params[0]['PO'] || this.aaPagesDefaultPO[this.pageName] || "";
        this.cmp = params[0]['cmp'] || params[0]['CMP'] || '';
        this.acquisitionType = params['activityType'] || "";
        this.oc = params['OC'] || "";
        this.pageId = (!!this.category && this.category === "raf-aadvantage-credit-card-page") ? "CitiRAFNGA" : 'CitiPDPNGA';
        this.isAACategory = this.aaPages?.includes(this.pageName)
        this.isFamilyPage = this.pageName?.includes('all-cards');
        this.qpStoreService.setEAPPageQueryParams(params[0], (this.isFamilyPage ? this.qpStoreService.PAGE_TYPE_MPP : this.qpStoreService.PAGE_TYPE_PDP));
        if (this.isFamilyPage) {
          this.afcCode = this.qpStoreService.setMPPQPCookie() || this.afcCode;
        }
        if (this.isAACategory) {
          this.qpStoreService.deleteEAPQPCookies();
        }
        this._offerUtilService.flowParams = {
          ...this._offerUtilService.flowParams,
          intc: this.intcCode,
          afc: this.afcCode,
          pageId: this.pageId || "",
          soc: this.soc || "",
          rafid: this.rafid || "",
          category: this.category || "",
          PO: this.PO || "",
          flowId: this.flowId || "",
          isAACategory: this.isAACategory || false,
          ...(this.isAACategory ? { cmp: this.cmp || "" } : {})
        };
        this.isInternal = (this.hashCode === "");
        this.loadContent();
      },
      error: () => {
        console.log("Something went wrong !!!");
      }
    }));
  }


  // Additional info modal feature start
  private getAdditionalInfoData(cardName = '') {
    let additionalInfoCardContent;

    if (this.pageDataObj.additionalInfoData) {
      additionalInfoCardContent = this.pageDataObj.additionalInfoData;
      additionalInfoCardContent.isHtmlContent = true;
      return additionalInfoCardContent;
    } else {
      additionalInfoCardContent = this._mktContentService.get(ADDITIONAL_INFO_PAGES, 'copy', cardName, undefined);
      const cardAdditionalInfoContent = !!additionalInfoCardContent && JSON.parse(additionalInfoCardContent.TEXT || '{}');
      return cardAdditionalInfoContent;
    }
  }

  private updateAdditionalInfoUrl() {
    if (this.isFamilyPage) return;
    const currentPageURL = this.router.url.split('?');
    let urlPath = currentPageURL[0].split('/');
    urlPath = urlPath.filter(part => part != ADDITIONAL_INFO_URL);
    urlPath.push(ADDITIONAL_INFO_URL);
    if (currentPageURL[1]) {
      this.location.replaceState(urlPath.join('/'), currentPageURL[1]);
    } else {
      this.location.replaceState(urlPath.join('/'));
    }
  }

  openAdditionalInfoPage(event: MouseEvent, addInfoCardName: string, addInfoPDPContentId: string, pid?: '') {
    if (event.type === "keyup" && event['keyCode'] != 13) return;
    const additionalInfoData = this.getAdditionalInfoData(addInfoPDPContentId);
    let additionalInfoDataObj;
    if (additionalInfoData.isHtmlContent) {
      additionalInfoDataObj = {
        title: additionalInfoData.heading.plaintext,
        content: additionalInfoData.description.plaintext,
        siteCatalyst: {},
        showCancelButton: true,
        cancelButtonText: '',
        primaryButtonText: 'Close',
        url: '',
        useDefaults: false,
        isModalScrollable: true,
        ...additionalInfoData
      };
    } else {
      this.updateAdditionalInfoUrl();
      additionalInfoDataObj = {
        content: '',
        siteCatalyst: {},
        showCancelButton: true,
        cancelButtonText: 'Close',
        primaryButtonText: '',
        url: '',
        useDefaults: false,
        isModalScrollable: true,
        ...additionalInfoData
      };
      additionalInfoDataObj.genericTemplateContent = additionalInfoData;
      const modalTitle = this.adaFriendlyNamePipe.ariaLabel(additionalInfoDataObj?.title || 'Additional Information');
      this.titleService.setTitle(modalTitle);
    }

    if (!this.isModalOpen) {
      this.isModalOpen = true;
      const modalInstance = this.modalService.openModal(event, additionalInfoDataObj, false);

      const handleOnClose = () => {
        this.isModalOpen = false;
        this.closeAdditionalInfoPage();
        this.titleService.setTitle(this.pageDataObj?.pageInfo?.pageTitle?.plaintext?.trim());
        modalCloseSub.unsubscribe();
        modalContinueSub.unsubscribe();
      };

      // Subscribe to modal close emitter
      const modalCloseSub = !!modalInstance && modalInstance.onClose.subscribe(handleOnClose.bind(this));

      // Subscribe to modal continue emitter
      const modalContinueSub = !!modalInstance && modalInstance.onContinue.subscribe(handleOnClose.bind(this));
      if (this.isFamilyPage) {
        this._pdpTaggingService.additionalInfoClickedFamily(pid);
      } else {
        this._pdpTaggingService.additionalInfoClicked();
      }
    }

    return false;
  }
  private closeAdditionalInfoPage() {
    console.log('onclose -model');
    if (!this.isAACategory) {
      const arr = this.router.url.split('?');
      arr[0] = arr[0].split('/').filter(part => part != ADDITIONAL_INFO_URL).join('/');
      this.location.replaceState(arr.join('?'));
    }

  }

  private loadContent() {
    try {
      if (this.pageNotFound) throw "Route Validation Failed";
      if (!this.pageDataObj) {
        // console.log(`>>> ${this.pageName}: AEM and ICMS Contents loading...`);
        const pageType = this.isFamilyPage ? 'family' : 'pdp';
        const aemContent = JSON.parse(this._contentStorageService.getByAppId(pageType) || 'null');
        if (aemContent == null) throw "AEM Content Not Loaded"; else console.log(`>>> ${this.pageName}: AEM and ICMS Contents Loaded!`);
        this.pageDataObj = this._pdpRedesignService.getDataBasedOnPageType(aemContent, pageType);
        // console.log(`>>> ${this.pageName}: Page data prepared.`);
      }
      if (!this.isAACategory && !this.isFamilyPage) {
        const hkopFromCookie = this.qpStoreService.setPDPQPCookie(this._pdpRedesignService.pidPT);        
        this.hashCode = hkopFromCookie ? hkopFromCookie : this.hashCode;
        const afcFromCookie = this.qpStoreService.getAfcCodeFromEAPCookie(this.qpStoreService.PAGE_TYPE_PDP, this._pdpRedesignService.pidPT);
        if (afcFromCookie) {
          this.afcCode = afcFromCookie;
        }
      }

      this.isInternal = (this.hashCode === "");
      this.initilizeSetUp(this.pageDataObj || {});
      console.log(`>>> ${this.pageName}: SSR process completed!`);
    } catch (error) {
      console.error(`>>> ${this.pageName}: Failed to load content!`, error);
      this.router.navigateByUrl('page-not-found');
    } finally {
      this.browserInit();
    }
  }

  public getStickyData(): void {
    const stickyTemplates = ['pdp_cta_sticky', 'pdp2_cta_sticky', 'family_cta_sticky'];
    this.stickyCompData = this.pageDataObj?.componentList?.find((item) => stickyTemplates.includes(item?.data?.template)) || {};
    this.showStickyHeader = this.stickyCompData?.data?.classList?.includes('header') && this.isAACategory;
    this.showStickyFooter = false;
    this.compDataExceptSticky = this.pageDataObj?.componentList?.filter((item) => !(stickyTemplates.includes(item?.data?.template))) || [];
  }

  updateDefaultVariables({ metadata, pageInfo }) {
    if (!this.screenId) this.screenId = metadata[0]?.screenId || '';
    if (!this.intcCode) this.intcCode = pageInfo?.intc || '';
    if (!this.afcCode) this.afcCode = pageInfo?.afc || '';
    this._offerUtilService.flowParams = {
      ...this._offerUtilService.flowParams,
      screenId: this.screenId,
      intc: this.intcCode,
      afc: this.afcCode
    }
  }

  initilizeSetUp(response) {
    // console.log(`>>> ${this.pageName}: initial setup initiated...`);
    if (this.pageNotFound) return;
    const themeList = response?.pageInfo?.themeName.split(" ");
    themeList.map(theme => this._pdpRedesignService.loadDynamicStyle(`/credit-cards/static-assets/${theme}.css`));
    this.isBundleLoaded = (Object.keys(response).length > 0);
    this.state.set(IS_BUNDLE_LOADED_KEY, this.isBundleLoaded);
    // console.log(`>>> ${this.pageName}: Updating default variables...`);
    this.updateDefaultVariables(response);
    // this.pageId = this.pageName;
    let seoTags = this.formatSeoData(response?.pageInfo);
    if (!this._pdpRedesignService.isBrowser) this.mktSEOService.setContentfulSeoTags(seoTags);
    this.titleService.setTitle(response?.pageInfo?.pageTitle?.plaintext?.trim());
    this._pdpTaggingService.setTag(this.pageDataObj?.pageInfo?.taggingDetails[0] || null);
    this.getStickyData();
  }

  private async browserInit() {
    if (this._pdpRedesignService.isBrowser) {
      // console.log(`>>> ${this.pageName}: Fetching dynamic values...`);
      await this._offerUtilService.loadBundleContent({ isAddInfo: !this.isAACategory });
      if (this.route.snapshot.data.isAdditionalInfo && !this.isFamilyPage) this.openAdditionalInfoPage(new MouseEvent('click'), "", (this.pageDataObj.metadata[0].contentId || this.pageName));
      if (this.isBrowser) {
        this.isFamilyPage ? this.getDynamicPricing() : this.getDynamicOffer();
      }
    }
  }

  ngAfterViewInit() {
    if (!this._pdpRedesignService.isBrowser) return;
    if (this.isAACategory) this.handleReferCode();
    this.initializeExternalUrls();
    this.handleInternalUrls();
    this.resize();
    this.sub.add(
      fromEvent(window, 'scroll').pipe(
        debounceTime(200) // Adjust debounce time as needed
      ).subscribe(() => this.handleStickyBehavior())
    );

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private handleReferCode() {
    const stickyRef = this.outlet()?.componentInstance;
    !!stickyRef && this.sub.add(stickyRef?.ctaClick?.subscribe(_ => {
      const url = `${this.applyNowUrl}&referralId=${stickyRef.sixDigitCode}`;
      const applyNowBtn1 = <any>(this._document.querySelector("tds-family-cta-sticky  .sticky1 .cds-button"));
      const applyNowBtn2 = <any>(this._document.querySelector("tds-family-cta-sticky .sticky2 .cds-button"));
      if (applyNowBtn1) {
        this.renderer2.setProperty(applyNowBtn1, 'href', url)
      }
      if (applyNowBtn2) {
        this.renderer2.setProperty(applyNowBtn2, 'href', url)
      }

    }));

    !!stickyRef && stickyRef?.formGroup?.valueChanges.pipe(debounceTime(2000)).subscribe(_ => {
      if (stickyRef.formGroup.invalid) this._pdpTaggingService.validationClicked(stickyRef.errorMessage);
    });
  }

  handleInternalUrls() {
    if (!this._pdpRedesignService.isBrowser) return;
    const instance = setTimeout(() => {
      const internalLinks = [...this.elementRef.nativeElement.querySelectorAll('.text-decoration-underline'), ...this.elementRef.nativeElement.querySelectorAll('.internal-link')];
      for (let i = 0; i < internalLinks.length; i++) {
        const currentLink = internalLinks[i];
        const isExternal = currentLink.classList.contains('external-link');
        if (isExternal || currentLink.classList.contains('tagging-added')) continue; // Skip if already processed or external link
        this.renderer2.listen(currentLink, 'click', (event) => {
          const linkName = this._ada.sanitizePlainText(event?.currentTarget?.innerText) || '';
          this.renderer2.addClass(currentLink, 'tagging-added');
          if (this.isFamilyPage) {
            const dataId = event?.currentTarget?.getAttribute('data-id');
            let pid = event?.currentTarget?.getAttribute('data-pid');
            if (!pid) pid = dataId?.split("-")[1] || "";
            this._pdpTaggingService.internalLinkClickedFamily(linkName.trim(), false, pid, this.familyPriceDetails);
          } else {
            let section = event?.currentTarget?.getAttribute('data-section') || '';
            if (!section) {
              const ref = event?.currentTarget?.getAttribute('data-sectionRef') || '';
              const headerRef = (!!ref) ? this.elementRef.nativeElement.querySelector(`#${ref}`) : {};
              section = this._ada.sanitizePlainText(headerRef?.innerText) || '';
            }
            const taggingMethod = currentLink.classList.contains('anchor-link-tagging')
              ? 'anchorLinkClicked'
              : 'internalLinkClicked';
            this._pdpTaggingService[taggingMethod](linkName.trim(), section);
          }
        });
      }
      clearTimeout(instance);
    }, 500);
  }

  public disableApplyNowBtns() {
    this.sub.add(timer(0).subscribe(() => {
      const applyNowBtn1 = <any>(this._document.querySelector("tds-family-cta-sticky  .sticky1 .cds-button"));

      const applyNowBtn2 = <any>(this._document.querySelector("tds-family-cta-sticky .sticky2 .cds-button"));

      const inputField1 = <any>(this._document.querySelector("tds-family-cta-sticky  .sticky1  .cds-input"));

      const inputField2 = <any>(this._document.querySelector("tds-family-cta-sticky  .sticky2  .cds-input"));
      if (applyNowBtn1) {
        this.renderer2.setAttribute(applyNowBtn1, 'aria-disabled', 'true');
        this.renderer2.addClass(applyNowBtn1, 'disabled-link');
      }
      if (applyNowBtn2) {
        this.renderer2.setAttribute(applyNowBtn2, 'aria-disabled', 'true');
        this.renderer2.addClass(applyNowBtn2, 'disabled-link');
      }
      if (inputField1) {
        this.renderer2.setAttribute(inputField1, 'disabled', 'true');
      }
      if (inputField2) {
        this.renderer2.setAttribute(inputField2, 'disabled', 'true');
      }
    }));

  }

  private getDynamicPricing = () => this._offerUtilService.getAllDynamicOffer({ pageId: this.pageId, affinityId: this.afcCode, category: this.category, screenId: this.screenId, intc: this.intcCode, isBannerCallRequired: false, rewardProgramType: 'VAC' }, message => {
    console.log(`FAMILY: Price loaded ${message}`);
    const priceDetails = this.state.get(PRICE_DETAILS_KEY, []);
    if (priceDetails.length > 0) {
      this.familyPriceDetails = priceDetails.filter(({ productIdentifier }) => !!productIdentifier && this.pageDataObj?.metadata?.some(v => v?.pid == productIdentifier));
      console.log(`>>> : Proceed with dynamic Values...`);
      this.handleDynamicPricing(this.familyPriceDetails);
      this.initializeExternalUrls();
      this.loadPageViewTagging(this.familyPriceDetails);
    }
  });


  private getDynamicOffer() {
    if (!this.isBrowser) return;
    if (this.isAACategory) {
      const afcHKOPMappingObj = this.pageDataObj?.pageInfo?.afcHKOPMapping;
      const defaultAFC = afcHKOPMappingObj['defaultAFC'];
      if (!!this.afcCode && afcHKOPMappingObj?.[this.afcCode]) {
        this.hashCode = afcHKOPMappingObj?.[this.afcCode]
      } else {
        this.afcCode = `${defaultAFC}`;
        this.hashCode = afcHKOPMappingObj?.[`${defaultAFC}`]
      }
      if (!this.hashCode) {
        this.disableApplyNowBtns();
        return;
      }
    }

    const { pid, productType, app } = this.pageDataObj?.metadata[0];
    const dynamicOfferServiceReq = this._mktDynamicOfferService.getDynamicOffer(this.pageId, pid, this.afcCode, this.hashCode, productType);
    this.sub.add(dynamicOfferServiceReq.subscribe({
      next: dynamicOffer => {
        this.sub.add(timer(0).subscribe(_ => {
          let pricingObj = { ...dynamicOffer, ...dynamicOffer['pricingDetails'] };
          delete pricingObj.pricingDetails;
          pricingObj = this._offerUtilService.handleDymamicUrls(pricingObj, "", this._offerUtilService.flowParams);
          this.handleDynamicPricing([{ ...pricingObj }]);
          this.initializeExternalUrls();
          this.loadPageViewTagging([{ ...pricingObj }]);
        }));
      },
      error: _ => {
        console.log("PDP price retrive call failed.")
        if (this.isAACategory) {
          this.disableApplyNowBtns();
          return;
        }
        let dynamicUrl = {
          'applyNowUrl': "javascript:0",
          'termsUrl': "javascript:0"
        };
        this._mktDynamicOfferService.setApplyNowContent(dynamicUrl);
        this._offerUtilService.injectDynamicUrls(this.elementRef, this.renderer2, dynamicUrl, pid);
      }
    }));
  }

  cardArtCliked(e) {
    console.log('card art clicked!!!');
  }

  private initializeExternalUrls() {
    if (!this._pdpRedesignService.isBrowser) return;
    this.sub.add(timer(500).subscribe(() => {
      const externalLinks = this.elementRef.nativeElement.querySelectorAll('.external-link');
      for (let i = 0; i < externalLinks.length; i++) {
        const currentLink = externalLinks[i];
        const hrefValue = currentLink.href;
        if (currentLink.classList.contains('popup')) continue; // Skip if already processed
        this.renderer2.listen(currentLink, 'click', (event) => this.openModal(event, hrefValue));
        this.renderer2.setAttribute(currentLink, 'href', 'javascript:;');
        this.renderer2.addClass(currentLink, 'popup');
        this.renderer2.setAttribute(currentLink, 'target', '_self');
        this.renderer2.setAttribute(currentLink, 'role', 'link');
        this.renderer2.setAttribute(currentLink, 'tabindex', '0');
      }
    }));
  }

  private openModal(event, url) {
    if (event.currentTarget) {
      if (!this.isFamilyPage) {
        let section = event?.currentTarget?.getAttribute('data-section') || '';
        if (!section) {
          const ref = event?.currentTarget?.getAttribute('data-sectionRef') || '';
          const headerRef = this.elementRef.nativeElement.querySelector(`#${ref}`);
          section = this._ada.sanitizePlainText(headerRef.innerText);
        }
        const value = this._ada.sanitizePlainText(event?.currentTarget?.innerText) || '';
        this._pdpTaggingService.externalLinkClicked(value.trim(), section);
      }
    }
    this.modalService.openModal(event, {
      url: url,
      isExternalLink: true,
      primaryButtonText: 'Continue',
      target: '_blank'
    });
  }


  formatSeoData(pageInfo) {
    return ({
      ...pageInfo,
      schemaTags: (pageInfo?.schemaTags || []).map(item => {
        const updatedSchemaJson = JSON.parse(JSON.stringify(item.schemaJson).replace(/"schema@type":/g, '"@type":'));
        return { ...item, schemaJson: updatedSchemaJson };
      })
    })
  }

  loadPageViewTagging(pricingDetails: any[]) {
    if (this._pdpRedesignService.isBrowser) {
      if (pricingDetails.length > 0) {
        let pid = '';
        const products = [];
        let productName = '';
        const { productType } = this._mktContentService.get('Branding', 'copy', 'BannerConfig', undefined);
        this._pdpTaggingService.taggingCardNameMap = JSON.parse(productType || '{}');
        this._pdpTaggingService.taggingObj = (this.isFamilyPage ? this._pdpTaggingService.familyTaggingObj : this._pdpTaggingService.taggingObj);
        pricingDetails?.forEach((v) => {
          // Allow the list of products based on AEM Content (pageDataObj)
          pid += `${v?.['productIdentifier']},`;
          productName = this._pdpTaggingService?.taggingCardNameMap[v?.['productIdentifier']];
          products.push({
            "category": 'cards:acquisition',
            "product_name": `c:${!!v.hashCode ? v.productIdentifier : productName}`,
            "acquisition_source_code": v.hashCode || '',
          });
        });
        this._pdpTaggingService.taggingObj.pid = pid.slice(0, -1); //remove last comma
        this._pdpTaggingService.taggingObj.products = products;
        if (this.isFamilyPage) {
          this._pdpTaggingService.initTaggingFamilyPage(this.pageName);
        }
        else {
          this._pdpTaggingService.taggingObj.app_hierarchy = this._pdpTaggingService.taggingObj.app_hierarchy.replace("<card_product_name>", productName); // Applicable only to PDP
          if (this.isAACategory) this._pdpTaggingService.taggingObj.form_type += `|${this.PO}`;
          this._pdpTaggingService.taggingObj.affinity_code = this.afcCode;
          this._pdpTaggingService.taggingObj.prospect_id = this._offerUtilService.getProspectIDFromApplyNowURL(this.applyNowUrl);
          this._pdpTaggingService.initTaggingTransformationCc(this.pageName);
        }
      }
      if (this.pageName && this.pageName.includes('inflight-info')) {
        this.loadIFrame();
      }
    }
  }

  public loadIFrame() {
    // Create a <link> element
    if(this.displayTermsUrl){
      const iframeLink = document.createElement('iframe');

      // Set the attributes for prefetch
      iframeLink.src = this.displayTermsUrl;
      iframeLink.style.display = 'none'; // Hide the iframe
      iframeLink.style.width = '0'; // Set width to 0
      iframeLink.style.height = '0'; // Set height to 0
      // Append the <link> element to the <head>
      document.body.appendChild(iframeLink);
    }
  }

  // Tagging Work
  private getOutputEmitterData(): void {
    if (this.tdsOutputService?.ctaLinkClicked()?.target) {
      console.log('ctaClicked ==> ', this.tdsOutputService?.ctaLinkClicked());
      this.onPageLinkClick(this.tdsOutputService?.ctaLinkClicked());
    }
    if (this.tdsOutputService?.footerLinkClicked()?.target) {
      console.log('footerLinkClick ==> ', this.tdsOutputService?.footerLinkClicked()?.target);
      this.onPageLinkClick(this.tdsOutputService?.footerLinkClicked());
    }
    if (this.tdsOutputService?.cardArtClicked()?.target) {
      console.log('cardArtCliked ==> ', this.tdsOutputService?.cardArtClicked()?.target);
    }
    if (this.tdsOutputService?.familyStickyCloseClicked()?.event?.target) {
      if (this.tdsOutputService?.familyStickyCloseClicked()?.cardsShown) {
        this._pdpTaggingService.stickyCTAModalOpenFamily();
      }
      else {
        this._pdpTaggingService.stickyLinkClickedFamily('', false, this.familyPriceDetails, this.tdsOutputService?.familyStickyCloseClicked()?.headerName, true);
      }
    }
    if (this.tdsOutputService?.selectedEvent()) {// navbar selectedEvent
      this.navBarSelected();
    }
    if (this.tdsOutputService?.featureCardLinkClicked()) {
      // Adding delay in navigation to allow tagging call to be completed.
      const event = this.tdsOutputService?.featureCardLinkClicked()?.event || null;
      event?.preventDefault();
      event?.stopPropagation();
      const targetLink = event?.currentTarget?.href;
      this.sub.add(timer(500).subscribe(_ => {
        targetLink && this._window['open'](targetLink, '_self');
      }));
    }
    if (this.tdsOutputService?.benefitTileClicked()) {
      this.initializeExternalUrls();
      this.handleInternalUrls(); // Tagging call should be binded after the internal links are initialized.
      this.sub.add(timer(500).subscribe(_ => {
        this.pageDataObj.metadata[0].additionalInfoFootnoteAttributes = { "role": "link", "tabindex": "0", "style": "cursor: pointer" };
        this.pageDataObj.metadata[0].pricingInfoFootnoteAttributes = { "role": "link", "tabindex": "0", "style": "cursor: pointer", "target": "_blank", "rel": "noopener" };
        this.footnoteService.addFootNote(this.elementRef, this.renderer2,
          {
            ...this.pageDataObj?.metadata[0], pricingInfo: this.pageDataObj?.pricingAndInfoText || 'Important Pricing & Information',
            additionalInformationText: this.pageDataObj?.additionalInformationText || 'Additional Information',
            cardName: this.pageDataObj?.metadata[0]?.cardName || this.pageDataObj?.metadata[0]?.contentId
          },
          this.openAdditionalInfoPage, this, 'pdp')
      }));
      const { e, primaryBenefit } = this.tdsOutputService?.benefitTileClicked();
      if (e.currentTarget.classList.contains('pb-active')) return; // Fire only when its not activated.
      console.log('benefitTileClicked ==> ', { e, primaryBenefit });
      const position = parseInt(e?.currentTarget?.getAttribute('data-position') || '0');
      const value = this._ada.sanitizePlainText(primaryBenefit?.header) || '';
      this._pdpTaggingService.benefitClicked(value.toString(), (position + 1).toString());
    }
    if (this.tdsOutputService?.faqSectionClicked()) {
      const e = this.tdsOutputService?.faqSectionClicked();
      console.log('faqSectionClicked ==> ', e);
      const position = (parseInt(e.faqIndex) + 1);
      const value = this._ada.sanitizePlainText(e.faqData.title) || '';
      const show = e.isFaqOpen[e.faqIndex];
      if (e.isDrawer) {
        this._pdpTaggingService.drawarClick(value, position.toString(), show);
      }
      else this._pdpTaggingService.faqClick(value, position.toString(), show);
    }
  }

  private navBarSelected(): void {
    const { selectedOption, category } = this.tdsOutputService?.selectedEvent();
    console.log('selectedEvent ==> ', { selectedOption, category });
    const position = (parseInt(selectedOption) + 1).toString()
    const value = this._ada.sanitizePlainText(category?.categoryName) || '';
    if (this.isFamilyPage) {
      this._pdpTaggingService.navCategoryFamily(value);
    }
    else {
      this._pdpTaggingService.navCategory(value, position);
    }
    let queryParams = this._window['location']?.search || '';
    let targetUrl = category?.categoryLinkUrl;
    // Remove cmp to avoid creating duplicate PDP/MPP cookies
    // Remove the leading "?" if present
    const params = new URLSearchParams(queryParams.startsWith('?') ? queryParams.slice(1) : queryParams);    
    params.delete('cmp');
    params.delete('HKOP');
    
    // Rebuild the query string
    queryParams = params.toString() ? `?${params.toString()}` : '';
    if (queryParams?.length > 0) {
      targetUrl = `${targetUrl}${queryParams}`;
    }
    this.sub.add(timer(500).subscribe(_ => {
    this._window['location']?.assign(targetUrl);
    }));
  }

  onPageLinkClick(e: any) {
    if (!this._pdpRedesignService.isBrowser) return;
    const target = e.target as HTMLElement;
    const text = target.innerText || "";
    let cardName = e.target.getAttribute('data-cardName');
    const cardRef = target.getAttribute('data-cardRef');
    if (!cardName) cardName = target.ariaLabel?.replace(text, "")?.trim() || "";
    const dataId = e.target.getAttribute('data-id');
    let section = e.target.getAttribute('data-section') || "";
    section = this.replacePlaceHolderValue(section);
    let pid = e.target.getAttribute('data-pid');
    if (!pid) pid = dataId?.split("-")[1] || "";
    const isApplyNow = dataId.includes("applyNowUrl");
    const isAddInfo = dataId.includes("additionalInfo");
    if ((section.charAt(0) === '1')) section = section.slice(1);
    // Family page tagging
    if (this.isFamilyPage) {
      if (section?.includes('sticky') && this._window?.['innerWidth'] < 992) {
        this._pdpTaggingService?.stickyLinkClickedFamily(pid, isApplyNow, this.familyPriceDetails, text?.trim(), false);
        return;
      }
      this._pdpTaggingService.internalLinkClickedFamily(text.trim(), isApplyNow, pid, this.familyPriceDetails, section);
      if (isAddInfo) this.openAdditionalInfoPage(e, cardName, cardRef, pid);
      return;
    }
    // PDP page tagging
    if (isApplyNow) {
      if (this.isFamilyPage) {
        this._pdpTaggingService.internalLinkClickedFamily(text.trim(), isApplyNow, pid, this.familyPriceDetails);
      } else this._pdpTaggingService.applyNowClicked(section);
    }
    else if (isAddInfo) {
      this._pdpTaggingService.internalLinkClicked(text.trim(), section);
      this.openAdditionalInfoPage(e, cardName, cardRef);
    } else {
      this._pdpTaggingService.internalLinkClicked(text.trim(), section);
    }
  }

  replacePlaceHolderValue(section) {
    if (!section) return section;
    const match = section.match(/data-id="([^"]+)"/);
    const dataId = match ? match[1] : null;
    if (dataId) {
      let ref = this.elementRef.nativeElement.querySelector(`[data-id="${dataId}"]`);
      if (!!ref && ref.parentNode) section = ref.parentNode.innerText;
    }
    return this._ada.sanitizePlainText(section) || '';
  }

  private handleStickyBehavior(): void {
    if (this.isAACategory && this.showStickyHeader) {
      return;
    }
    if (!this._pdpRedesignService.isBrowser) return;
    // Determine the target element based on the page type
    const targetElement = this.isFamilyPage ? this._document.querySelector("tds-family-cards") : this._document.querySelector("tds-feature section");
    const targetElementTop = targetElement?.getBoundingClientRect()?.top || 1000; // Use optional chaining and default value

    const scrollTop = this._document.documentElement.scrollTop || this._document.body.scrollTop || 0;

    // Update sticky header/footer visibility
    const stickyProperty = this.isFamilyPage ? 'showStickyHeader' : 'showStickyFooter';
    if (this[stickyProperty] === (scrollTop >= targetElementTop)) return;
    this[stickyProperty] = scrollTop >= targetElementTop;
    this.scrollSubject.next();
  }

  @HostListener("window:resize", [])
  private resize() {
    this.sub.add(timer(0).subscribe(async () => {
      if (!this._pdpRedesignService.isBrowser) return;
      this._pdpRedesignService.setDeviceSize();
      if (this.showStickyHeader) {
        let stickyComp = <any>(this._document.querySelector("tds-family-cta-sticky"));
        if (stickyComp) {
          this.stickyHeight = stickyComp.offsetHeight;
        }
      }
      this.pageDataObj.metadata.map(data => {
        let cardMetadata = {
          isPreLoginMbolFlow: data?.isPreLoginMbolFlow || false,
          isPostLoginMbolFlow: data?.isPostLoginMbolFlow || false,
          app: data?.app || '',
          pid: data?.pid || '',
          productType: data?.productType || '',
          contentId: data?.contentId || '',
          cardName: data?.cardName || ''
        };
        this.loadPriceInformation(cardMetadata);
      })
    }));
  }

  private handlePriceDependentEvent() {
    if (!this._pdpRedesignService.isBrowser) return;
    console.log('>>> Handling scroll event...');
    this.isFamilyPage ? this.handleDynamicPricing(this.familyPriceDetails) : this.handleDynamicPricing(this.state.get(PRICE_DETAILS_KEY, []));

  }

  private handleDynamicPricing(priceDetails = []) {
    this.pageDataObj.metadata.forEach(data => {
      const priceObj = priceDetails.filter(({ productIdentifier }) => productIdentifier === data?.pid)[0] || null;
      if (!priceObj) return;
      let cardMetadata = {
        isPreLoginMbolFlow: data?.isPreLoginMbolFlow || false,
        isPostLoginMbolFlow: data?.isPostLoginMbolFlow || false,
        app: data?.app || '',
        pid: data?.pid || '',
        productType: data?.productType || '',
        contentId: data?.contentId || '',
        cardName: data?.cardName || ''
      };
      const { isPreLoginMbolFlow, isPostLoginMbolFlow, app } = cardMetadata;
      let mbolParams = !!this.flowId ? ({ pre: this._offerUtilService.isMbolPreLoginFlow(this.flowId, isPreLoginMbolFlow), post: this._offerUtilService.isMbolPostLoginFlow(this.flowId, isPostLoginMbolFlow), app }) : ({});
      console.log(`${this.pageName}: Loading dynamic URLs...`);
      priceObj.isMbol = (mbolParams.pre || mbolParams.post);
      if (!this.isFamilyPage) {
        this.applyNowUrl = this._pdpRedesignService.aaApplyNow(priceObj.isMbol ? priceObj['mbol-apply-now-button'] : priceObj['apply-now-button'], this._offerUtilService.flowParams);
        priceObj['apply-now-button'] = this.applyNowUrl;
        this.displayTermsUrl = priceObj?.['terms-link'] || '';
        this.hashCode = !!this.hashCode ? this.hashCode : priceObj?.hashCode;
        this.pid = priceObj?.productIdentifier;
        this.state.set(PRICE_DETAILS_KEY, [{ ...priceObj }]);
      }
      this._pdpRedesignService.getDynamicUrls({ priceObj, pageId: this.pageId, flowParams: this._offerUtilService.flowParams, mbolParams });
      this.loadPriceInformation(cardMetadata);
      console.log(`>>> ${this.pageName}: All process completed successfully...`)
    })
  }

  private loadPriceInformation(cardDetail) {
    console.log(`${this.pageName}: Rendering Dynamic data on page...`);
    if (this.flagPQPS) {
      this.pqpsUtilService.updatePricingValuesPQPS(cardDetail.pid, this.elementRef, this.renderer2, this.acquisitionType, this.oc);
    } else {
      this._offerUtilService.populateDynamicValues(cardDetail.pid, this.elementRef, this.renderer2, cardDetail.productType, cardDetail.app);
    }
    this.sub.add(timer(0).subscribe(() => {
      // get footnote attributes from AEM
      cardDetail.additionalInfoFootnoteAttributes = { "role": "link", "tabindex": "0", "style": "cursor: pointer" };
      cardDetail.pricingInfoFootnoteAttributes = { "role": "link", "tabindex": "0", "style": "cursor: pointer", "target": "_blank", "rel": "noopener" };
      this.footnoteService.addFootNote(this.elementRef, this.renderer2,
        {
          ...cardDetail, pricingInfo: this.pageDataObj?.pricingAndInfoText || 'Important Pricing & Information',
          additionalInformationText: this.pageDataObj?.additionalInformationText || 'Additional Information',
          cardName: cardDetail?.cardName || cardDetail?.contentId
        },
        this.openAdditionalInfoPage, this, 'pdp')
      this.footnoteService.addFootNote(this.elementRef, this.renderer2, this.pageDataObj?.metadata[0], this.scroll,
        this, 'pdp', 'scroll');
      this.setBgImgHeight();
    }));
  }

  private scroll = (event, elementId, page) => this.scrollFocusService.scrollFocus(event, elementId, page);

  private setBgImgHeight(): void {
    this.sub.add(timer(500).subscribe(() => {
      const bgImgRef = this._document.querySelector('.hero-placeholder');
      if (!!bgImgRef && (this._window['innerWidth'] >= 992)) {
        let contentHeight = this._document.querySelector('.hero-feature-section__content').clientHeight; // 152px is for padding top (56px) and bottom(96px)
        (bgImgRef as HTMLElement).style.height = `${contentHeight}px`;
      } else if (!!bgImgRef && this._window['innerWidth'] < 992) {
        (bgImgRef as HTMLElement).style.height = `160px`;
      }
    }));
  }

  private set afcCode(value: string) {
    if (this._afcCode !== value) {
      this._afcCode = value;
      // Automatically update flowParams whenever afcCode changes
      this._offerUtilService.flowParams = {
        ...this._offerUtilService.flowParams,
        afc: this._afcCode
      };
    }
  }

  private get afcCode(): string {
    return this._afcCode;
  }

}
